"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
const Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
const SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const translations_json_1 = __importDefault(require("./translations.json"));
const AsyncErrorComponent = () => {
    const theme = (0, react_jss_1.useTheme)();
    const translations = translations_json_1.default;
    const translation = translations[theme.language] ?? translations.en;
    return (react_1.default.createElement(Flex_1.default, { wrap: true, alignItems: "start" },
        react_1.default.createElement("h2", null, translation["error_header"]),
        react_1.default.createElement("p", null, translation["error_text"]),
        react_1.default.createElement(FlatButton_1.default, { label: "Refresh Page", iconLeft: react_1.default.createElement(SvgIcon_1.default, { name: "refresh" }), onClick: () => {
                if (typeof window !== "undefined")
                    window.location.reload();
            } })));
};
exports.default = AsyncErrorComponent;
